export function debounceWithCallAPI(func, wait, callback, setShowLoader, sendEntireResponse = false) {
  let timeout;
  let promiseApiCall;

  const debouncedFn = function (...args) {
    if (promiseApiCall && promiseApiCall.cancel) {
      promiseApiCall.cancel();
    }
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      promiseApiCall = func(...args);
      if (promiseApiCall) {
        promiseApiCall
          .then((res) => {
            if (setShowLoader) {
              setShowLoader(false);
            }
            // res.data.length > 0 will keep the last response in the state
            if (res && callback) { // && res.data.length > 0) {
              callback(sendEntireResponse ? res : res.data);
            }
          }).catch(() => {
          });
      }
    }, wait);
  };

  debouncedFn.cancel = () => {
    clearTimeout(timeout);
    if (promiseApiCall && promiseApiCall.cancel) {
      promiseApiCall.cancel();
    }
  };

  return debouncedFn;
}
